import React from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { DomeText, Header2, Header5, Header6 } from "../components/typography";
import richText from "../utils/richText";

const Wrapper = styled.div`
  padding: 64px 32px;
  background: ${Colors.cream1};

  ${Header2} {
    margin: 24px auto 40px;
    max-width: 800px;

    color: ${Colors.grey};
    text-align: center;
  }

  > div:last-child div:first-child {
    ${DomeText} {
      text-align: center;
      display: block;
      color: ${Colors.greyLight};
    }

    ${Header6} {
      color: ${Colors.hunter};
      text-align: center;

      margin: 8px 0 40px;
    }
  }

  @media ${Breakpoints.tablet} {
    > div:last-child div:first-child {
      ${DomeText}, ${Header6} {
        text-align: left;
      }
    }
  }
`;

const Row = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  @media ${Breakpoints.tablet} {
    display: flex;

    > div {
      flex: 1 1 50%;
    }

    > div:first-child {
      padding-right: 50px;

      border-right: 1px solid ${Colors.webGrey};
    }

    > div:last-child {
      padding-left: 50px;
    }
  }
`;

const BodyWrapper = styled.div`
  color: ${Colors.greyLight};
  max-width: 490px;
  margin: 0 auto;

  p {
    margin: 16px 0;
  }

  ${Header5} {
    margin-top: 40px;
    color: ${Colors.grey};
  }
`;

export default function Manifesto({ headline, choices, body }) {
  return (
    <Wrapper>
      <DomeHeader text="Our Manifesto" centered />
      <Header2>{headline}</Header2>
      <Row>
        <div>
          {choices.map((choice) => (
            <div>
              <DomeText>We Choose</DomeText>
              <Header6 as="p">{choice}</Header6>
            </div>
          ))}
        </div>
        <div>
          <BodyWrapper>{richText(body)}</BodyWrapper>
        </div>
      </Row>
    </Wrapper>
  );
}
